module.exports = __webpack_public_path__ + "img/16.9ff889a8.webp";